<script>

  const horizonalLinePlugin = {
    id: 'horizontalLine',
    afterDraw: function (chartInstance) {

      var yValue;
      var yScale = chartInstance.scales["y-axis-0"];
      var canvas = chartInstance.chart;
      var ctx = canvas.ctx;
      var index;
      var line;
      var style;

      if (chartInstance.options.horizontalLine) {

        for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
          line = chartInstance.options.horizontalLine[index];

          if (!line.style) {
            style = "#080808";
          } else {
            style = line.style;
          }

          if (line.y) {
            yValue = yScale.getPixelForValue(line.y);
          } else {
            yValue = 0;
          }
          ctx.lineWidth = 3;

          if (yValue) {
            window.chart = chartInstance;
            ctx.beginPath();
            ctx.moveTo(0, yValue);
            ctx.lineTo(canvas.width, yValue);
            ctx.strokeStyle = style;
            ctx.stroke();
          }

          if (line.text) {
            ctx.fillStyle = style;
            ctx.fillText(line.text, 0, yValue + ctx.lineWidth);
          }
        }
        return;
      }
    }
  };

  import {Bar} from 'vue-chartjs'
  import {getStyle} from '@coreui/coreui-pro/dist/js/coreui-utilities'
  import _ from 'lodash';


  export default {
    props: ['data', 'avg_net_kilograms_day', 'max_net_kilograms_day'],
    name: "ProcessStackedBarChart",
    extends: Bar,
    beforeMount() {
      this.addPlugin(horizonalLinePlugin)
    },
    computed: {
      labels() {
        return _.map(this.data, 'day')
      },
      dataset1() {
        return _.map(this.data, 'sum_net_kilograms')
      },
      dataset2() {
        return _.map(this.data, 'exportable_kilograms')
      },

    },
    mounted() {
      var dataset1 = this.dataset1
      var dataset2 = this.dataset2
      const avg = this.avg_net_kilograms_day;
      const max = this.max_net_kilograms_day;
      var per = dataset2.map(function (num, idx) {
        return (parseFloat(num) / parseFloat(dataset1[idx]) * 100).toFixed(2);
      });
      const avg_day = dataset2.map(function (num, idx) {
        return avg.toFixed(2);
      });
      const max_day = dataset2.map(function (num, idx) {
        return max.toFixed(2);
      });

      const brandPrimary = getStyle('--primary')
      const brandSuccess = getStyle('--success')
      const brandSecondary = getStyle('--secondary')
      const brandDanger = getStyle('--danger') || '#f86c6b'
      this.renderChart({
          labels: this.labels,
          datasets: [
            {
              label: 'Promedio Kgs Embalados por día',
              backgroundColor: 'transparent',
              borderColor: brandDanger,
              pointHoverBackgroundColor: brandDanger,
              borderWidth: 1,
              borderDash: [8, 5],
              data: avg_day,
              type: 'line'
            },
            {
              label: 'Máximo de Kgs Embalados/día',
              backgroundColor: 'transparent',
              borderColor: brandSuccess,
              pointHoverBackgroundColor: brandSuccess,
              borderWidth: 1,
              borderDash: [8, 5],
              data: max_day,
              type: 'line'
            },
            {
              label: 'Kgs Embalados',
              backgroundColor: brandPrimary,
              data: this.dataset2
            },
            {
              label: 'Kgs Volteados',
              backgroundColor: brandSecondary,
              data: this.dataset1,
            },


          ]
        },
        {
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              afterBody: function (t, d) {
                return 'Porcentaje de embalaje ' + per[t[0].index] + '%';  // return a string that you wish to append
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              stacked: true,
              categoryPercentage: 0.5,
              barPercentage: 1
            }],
            yAxes: [{
              stacked: false,
              ticks: {
                beginAtZero: true,
              },
            }]
          }
        })
    }
  }
</script>

<style scoped>

</style>

